module.exports = __webpack_public_path__ + "img/wald.740d270c.jpg";